/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectInformationResourceFreelancerAppraisalRating } from './';
import {
    ProjectInformationResourceFreelancerAppraisalRatingFromJSON,
    ProjectInformationResourceFreelancerAppraisalRatingFromJSONTyped,
    ProjectInformationResourceFreelancerAppraisalRatingToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectInformationResourceFreelancerAppraisal
 */
export interface ProjectInformationResourceFreelancerAppraisal {
    /**
     * 
     * @type {ProjectInformationResourceFreelancerAppraisalRating}
     * @memberof ProjectInformationResourceFreelancerAppraisal
     */
    rating?: ProjectInformationResourceFreelancerAppraisalRating;
    /**
     * 
     * @type {string}
     * @memberof ProjectInformationResourceFreelancerAppraisal
     */
    comment?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProjectInformationResourceFreelancerAppraisal
     */
    creationDate?: Date;
}

/**
 * Check if a given object implements the ProjectInformationResourceFreelancerAppraisal interface.
 */
export function instanceOfProjectInformationResourceFreelancerAppraisal(value: object): value is ProjectInformationResourceFreelancerAppraisal {
    return true;
}

export function ProjectInformationResourceFreelancerAppraisalFromJSON(json: any): ProjectInformationResourceFreelancerAppraisal {
    return ProjectInformationResourceFreelancerAppraisalFromJSONTyped(json, false);
}

export function ProjectInformationResourceFreelancerAppraisalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInformationResourceFreelancerAppraisal {
    if (json == null) {
        return json;
    }
    return {
        
        'rating': json['rating'] == null ? undefined : ProjectInformationResourceFreelancerAppraisalRatingFromJSON(json['rating']),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'creationDate': json['creationDate'] == null ? undefined : (new Date(json['creationDate'])),
    };
}

export function ProjectInformationResourceFreelancerAppraisalToJSON(value?: ProjectInformationResourceFreelancerAppraisal | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rating': ProjectInformationResourceFreelancerAppraisalRatingToJSON(value['rating']),
        'comment': value['comment'],
        'creationDate': value['creationDate'] == null ? undefined : ((value['creationDate']).toISOString()),
    };
}

